var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.334 8.731v2.046a.667.667 0 0 1-1.115.494L2.2 7.627a.666.666 0 0 1 .017-1.002l4.02-3.412a.666.666 0 0 1 1.098.508v1.624c3.642 0 6.667 2.248 6.667 5.988v.753C12.77 9.63 10.21 8.731 7.334 8.731",
    clipRule: "evenodd"
  })));
};
export { SvgShare as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTc4MzMyOThhZGI1YmViN2NkNjc0MjNjMzU5NjlkNGMuc3ZnIjs=";